import { useSearchParams } from "react-router-dom";

export function useUrlState() {
  const [searchParams, setSearchParams] = useSearchParams();

  const getSearchParam = (key: string): string | undefined => {
    return searchParams.get(key) ?? undefined;
  };

  const getAllSearchParams = (): Record<string, string> => {
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  /**
   * set a single search param
   */
  const setSearchParam = (key: string, value: string | undefined): void => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (value === undefined || value === "" || value === null) {
        next.delete(key);
      } else {
        next.set(key, value);
      }
      return next;
    });
  };

  /**
   * set multiple search params at once
   * merges with existing params unless set to undefined
   */
  const setMultipleSearchParams = (updates: Record<string, string | undefined>): void => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(updates).forEach(([key, value]) => {
        if (value === undefined || value === "" || value === null) {
          next.delete(key);
        } else {
          next.set(key, value);
        }
      });
      return next;
    });
  };

  return {
    getSearchParam,
    getAllSearchParams,
    setSearchParam,
    setMultipleSearchParams,
    searchParams
  };
}
